import ListSelect from '../ListSelect/ListSelect'
import {
  UPDATE_SELECTED_PLAYER,
  useFilterUpdate,
  useFilter
} from '../../contexts/FilterContext'
import PlayerData from '../../data/PlayerData'
import { getPlayerStatMap, getPlayerVisibleName } from '../../utils/DataUtils'

const PlayerFilter = ({ selectedPlayer }) => {
  const appliedFilters = useFilter()
  const filterDispatch = useFilterUpdate()

  const matchStats = getPlayerStatMap(null, appliedFilters.selectedTeamId, null)
  const playerIds = new Set(matchStats.keys())

  const players = PlayerData.filter((player) => playerIds.has(player.player_id))
    .map((player) => ({
      value: player.player_id,
      displayText: getPlayerVisibleName(player)
    }))
    .sort((a, b) => (a.displayText > b.displayText ? 1 : -1))

  return (
    <ListSelect
      options={players}
      label="Player"
      selectedValue={selectedPlayer}
      onChange={(value) =>
        filterDispatch({ type: UPDATE_SELECTED_PLAYER, payload: value })
      }
    />
  )
}

export default PlayerFilter
